export default "__VITE_ASSET__C$H52L0R__"